var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatbotLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0743 84.5656C36.5297 85.9474 39.7648 84.6107 43.6755 84.1294C47.027 83.4079 50.3226 83.0908 50.3226 83.0908L31.2934 69.9249C31.2934 69.9249 32.6124 73.3644 33.0442 77.0798C33.2232 78.62 33.5825 80.3363 33.7725 81.71C33.9512 83.002 34.3689 83.8958 35.0743 84.5656Z",
    fill: "#FF715B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1708 17.0401C54.2133 14.088 58.2623 13.3506 61.2145 15.3931L90.7609 35.8357C93.713 37.8782 94.4504 41.9272 92.4079 44.8793L91.0774 46.8023L88.9088 49.9367C86.8663 52.8888 82.8173 53.6262 79.8651 51.5837L50.3187 31.1412C47.3666 29.0986 46.6292 25.0497 48.6717 22.0975L52.1708 17.0401Z",
    fill: "#A09DFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8418 18.9634L91.0788 46.8025L72.6399 73.453L32.4029 45.6139L50.8418 18.9634Z",
    fill: "#A09DFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0839 84.0207C73.4179 80.6473 74.2205 76.4186 73.315 72.2648C72.4095 68.1111 69.8702 64.3726 66.2556 61.8718C62.6411 59.3709 58.2474 58.3126 54.0411 58.9297C49.8349 59.5467 46.1606 61.7885 43.8266 65.1619L57.4552 74.5913L71.0839 84.0207Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0547 77.5306C59.339 76.6594 59.5015 75.0244 59.0449 74.2322C58.1883 73.6901 56.3695 73.4205 55.0852 74.2917C53.8009 75.1629 53.548 76.7661 54.0941 77.5907C55.0956 78.1927 56.7703 78.4018 58.0547 77.5306Z",
    fill: "#FB6DC3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1708 17.0401C54.2133 14.088 58.2623 13.3506 61.2145 15.3931L75.9877 25.6144L52.52 59.5332L32.4014 45.6136L52.1708 17.0401Z",
    fill: "#BFBDFD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3163 69.6516C52.6503 66.2781 53.4529 62.0494 52.5474 57.8957C51.6419 53.742 49.1026 50.0035 45.4881 47.5026C41.8735 45.0018 37.4798 43.9435 33.2735 44.5605C29.0673 45.1775 25.393 47.4194 23.059 50.7928L36.6877 60.2222L50.3163 69.6516Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7812 60.6323C34.1437 59.1233 35.6163 58.3948 36.5187 58.5429C37.328 59.1533 38.2215 60.7603 37.859 62.2693C37.4965 63.7783 36.0854 64.5801 35.1212 64.3597C34.2048 63.6348 33.4186 62.1413 33.7812 60.6323Z",
    fill: "#FB6DC3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2252 69.2721C50.4162 67.5797 50.0006 65.282 49.1679 64.3779C47.9564 63.9717 45.7115 64.314 44.5205 66.0064C43.3295 67.6989 43.6267 69.9885 44.577 70.9019C45.9816 71.3332 48.0342 70.9646 49.2252 69.2721Z",
    fill: "#FB6DC3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotLogo);
export default __webpack_public_path__ + "static/media/Chatbot_logo.e58ebe935bc5dc5eb053e4d8a030cd6f.svg";
export { ForwardRef as ReactComponent };